export default { "columns":25,
 "image":"stalactites.png",
 "imageheight":159,
 "imagewidth":400,
 "margin":0,
 "name":"stalactites",
 "spacing":0,
 "tilecount":225,
 "tiledversion":"1.11.2",
 "tileheight":16,
 "tiles":[
        {
         "id":0,
         "type":"decal"
        }, 
        {
         "id":1,
         "type":"decal"
        }, 
        {
         "id":2,
         "type":"decal"
        }, 
        {
         "id":3,
         "type":"decal"
        }, 
        {
         "id":4,
         "type":"decal"
        }, 
        {
         "id":5,
         "type":"decal"
        }, 
        {
         "id":6,
         "type":"decal"
        }, 
        {
         "id":7,
         "type":"decal"
        }, 
        {
         "id":8,
         "type":"decal"
        }, 
        {
         "id":9,
         "type":"decal"
        }, 
        {
         "id":10,
         "type":"decal"
        }, 
        {
         "id":11,
         "type":"decal"
        }, 
        {
         "id":12,
         "type":"decal"
        }, 
        {
         "id":13,
         "type":"decal"
        }, 
        {
         "id":14,
         "type":"decal"
        }, 
        {
         "id":15,
         "type":"decal"
        }, 
        {
         "id":16,
         "type":"decal"
        }, 
        {
         "id":17,
         "type":"decal"
        }, 
        {
         "id":18,
         "type":"decal"
        }, 
        {
         "id":19,
         "type":"decal"
        }, 
        {
         "id":20,
         "type":"decal"
        }, 
        {
         "id":21,
         "type":"decal"
        }, 
        {
         "id":22,
         "type":"decal"
        }, 
        {
         "id":23,
         "type":"decal"
        }, 
        {
         "id":25,
         "type":"decal"
        }, 
        {
         "id":26,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-4,
                             "y":10
                            }, 
                            {
                             "x":-4,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":4,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":27,
         "objectgroup":
            {
             "draworder":"index",
             "id":2,
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polyline":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":3,
                             "y":9
                            }, 
                            {
                             "x":6,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":6,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":28,
         "type":"decal"
        }, 
        {
         "id":29,
         "type":"decal"
        }, 
        {
         "id":30,
         "type":"decal"
        }, 
        {
         "id":31,
         "type":"decal"
        }, 
        {
         "id":32,
         "type":"decal"
        }, 
        {
         "id":33,
         "type":"decal"
        }, 
        {
         "id":34,
         "type":"decal"
        }, 
        {
         "id":35,
         "type":"decal"
        }, 
        {
         "id":36,
         "type":"decal"
        }, 
        {
         "id":37,
         "type":"decal"
        }, 
        {
         "id":38,
         "type":"decal"
        }, 
        {
         "id":39,
         "type":"decal"
        }, 
        {
         "id":40,
         "type":"decal"
        }, 
        {
         "id":41,
         "type":"decal"
        }, 
        {
         "id":42,
         "type":"decal"
        }, 
        {
         "id":43,
         "type":"decal"
        }, 
        {
         "id":44,
         "type":"decal"
        }, 
        {
         "id":45,
         "type":"decal"
        }, 
        {
         "id":46,
         "type":"decal"
        }, 
        {
         "id":47,
         "type":"decal"
        }, 
        {
         "id":48,
         "type":"decal"
        }, 
        {
         "id":54,
         "type":"decal"
        }, 
        {
         "id":55,
         "type":"decal"
        }, 
        {
         "id":56,
         "type":"decal"
        }, 
        {
         "id":57,
         "type":"decal"
        }, 
        {
         "id":59,
         "type":"decal"
        }, 
        {
         "id":60,
         "type":"decal"
        }, 
        {
         "id":62,
         "type":"decal"
        }, 
        {
         "id":63,
         "type":"decal"
        }, 
        {
         "id":64,
         "type":"decal"
        }, 
        {
         "id":65,
         "type":"decal"
        }, 
        {
         "id":66,
         "type":"decal"
        }, 
        {
         "id":67,
         "type":"decal"
        }, 
        {
         "id":68,
         "type":"decal"
        }, 
        {
         "id":69,
         "type":"decal"
        }, 
        {
         "id":70,
         "type":"decal"
        }, 
        {
         "id":71,
         "type":"decal"
        }, 
        {
         "id":72,
         "type":"decal"
        }, 
        {
         "id":73,
         "type":"decal"
        }, 
        {
         "id":79,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":3,
                             "y":5
                            }, 
                            {
                             "x":6,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":81,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":2,
                             "y":12
                            }, 
                            {
                             "x":4,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":12,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":84,
         "type":"decal"
        }, 
        {
         "id":85,
         "type":"decal"
        }, 
        {
         "id":88,
         "type":"decal"
        }, 
        {
         "id":89,
         "type":"decal"
        }, 
        {
         "id":90,
         "type":"decal"
        }, 
        {
         "id":91,
         "type":"decal"
        }, 
        {
         "id":92,
         "type":"decal"
        }, 
        {
         "id":93,
         "type":"decal"
        }, 
        {
         "id":94,
         "type":"decal"
        }, 
        {
         "id":96,
         "type":"decal"
        }, 
        {
         "id":97,
         "type":"decal"
        }, 
        {
         "id":98,
         "type":"decal"
        }, 
        {
         "id":109,
         "type":"decal"
        }, 
        {
         "id":110,
         "type":"decal"
        }, 
        {
         "id":113,
         "type":"decal"
        }, 
        {
         "id":114,
         "type":"decal"
        }, 
        {
         "id":115,
         "type":"decal"
        }, 
        {
         "id":116,
         "type":"decal"
        }, 
        {
         "id":117,
         "type":"decal"
        }, 
        {
         "id":118,
         "type":"decal"
        }, 
        {
         "id":119,
         "type":"decal"
        }, 
        {
         "id":121,
         "type":"decal"
        }, 
        {
         "id":122,
         "type":"decal"
        }, 
        {
         "id":123,
         "type":"decal"
        }, 
        {
         "id":134,
         "type":"decal"
        }, 
        {
         "id":135,
         "type":"decal"
        }, 
        {
         "id":138,
         "type":"decal"
        }, 
        {
         "id":139,
         "type":"decal"
        }, 
        {
         "id":140,
         "type":"decal"
        }, 
        {
         "id":143,
         "type":"decal"
        }, 
        {
         "id":144,
         "type":"decal"
        }, 
        {
         "id":147,
         "type":"decal"
        }, 
        {
         "id":148,
         "type":"decal"
        }, 
        {
         "id":159,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":0,
                             "y":14
                            }, 
                            {
                             "x":6,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":10,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":163,
         "type":"decal"
        }, 
        {
         "id":164,
         "type":"decal"
        }, 
        {
         "id":168,
         "type":"decal"
        }, 
        {
         "id":169,
         "type":"decal"
        }, 
        {
         "id":172,
         "type":"decal"
        }, 
        {
         "id":189,
         "type":"decal"
        }, 
        {
         "id":193,
         "type":"decal"
        }, 
        {
         "id":194,
         "type":"decal"
        }, 
        {
         "id":197,
         "type":"decal"
        }, 
        {
         "id":214,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":3,
                             "y":3
                            }, 
                            {
                             "x":4,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":218,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":1,
                             "y":6
                            }, 
                            {
                             "x":4,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":11,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":222,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":4,
                             "y":8
                            }, 
                            {
                             "x":5,
                             "y":8
                            }, 
                            {
                             "x":7,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":5,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};